import { HttpResponseList } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { ResponsePrintReceiptPosData } from 'shell/models/print-receipt-pos-data';
import {
  FormPrintReceiptPos,
  PrintReceiptPosBody,
} from 'front-office/view-models/print-receipt-pos-page';
import { DateTime } from 'luxon';

export const transformerPrintReceiptPosData = (
  response: AxiosResponse<HttpResponseList<ResponsePrintReceiptPosData>>
): FormPrintReceiptPos => {
  const bodyTable: PrintReceiptPosBody[] = (response.data.payload?.list || []).map((item) => {
    const amount =
      Number.parseFloat(item?.importoBollo || '') +
      Number.parseFloat(item?.importoDirittiSegreteria || '') +
      Number.parseFloat(item?.importoDirittiStatoCivile || '') +
      Number.parseFloat(item?.importoDirittiFissi || '') +
      Number.parseFloat(item?.importoSpese || '');

    let ann = '';

    if (item.codiceStato === '1' || item.codiceStato === '2') {
      ann = 'NO';
    }

    if (item.codiceStato === '3' || item.codiceStato === '4') {
      ann = 'SI';
    }

    return {
      number:
        `${item.key?.codiceSiglaRegistro || ''}-${item.key?.idAnnoDocumento || ''}-${
          item.key?.progressivoDocumento || ''
        }` || '',
      type: item.tipoDocumento?.descrizioneTipoDocumento || '',
      modality: item.modalitaRilascio?.descrizione || '',
      amount: amount?.toString() || '',
      fiscalCode: item.codiceFiscaleIntestatario || '',
      dateCertificate: item.timestampRilascio
        ? DateTime.fromISO(item.timestampRilascio).toFormat('dd/MM/yyyy')
        : '',
      operator: item.codiceOperatoreRilascio || '',
      service: item.codiceServizioRilascio || '',
      ann,
    };
  });

  return {
    list: bodyTable || [],
    selected: [],
  };
};
